export const enum QueryStatus {
    Idle = 'idle',
    Loading = 'loading',
    Error = 'error',
    Success = 'success'
}

export type QueryStatusType = `${QueryStatus}`
